import { render } from "./meal-edit-page.vue?vue&type=template&id=7aa29cdd"
import script from "./meal-edit-page.vue?vue&type=script&lang=js"
export * from "./meal-edit-page.vue?vue&type=script&lang=js"

import "./meal-edit-page.vue?vue&type=style&index=0&id=7aa29cdd&lang=scss"

import exportComponent from "/Users/girgisnabil/Documents/projects/home-food-plus-full-stack/source/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__